import gql from 'graphql-tag';

import type {
  PreviousApplicationsQueryVariables,
  PreviousApplicationsQuery,
} from './fetchPreviousApplications.hirer.graphql.generated';
import hirerGraphClient from './hirer/client';

const query = gql`
  query PreviousApplications($input: PreviousApplicationsInput!) {
    previousApplications(input: $input) {
      ... on PreviousApplicationsResponseSuccess {
        applications {
          id
          applicationId
          adcentreProspectId
          adcentreCandidateId
          candidateId
          mostRecentJobTitle
          mostRecentCompanyName
          mostRecentRoleMonths
          appliedDateUtc
          statusFolder
          attachmentsV2 {
            ... on ApplicationAttachmentsV2ResponseSuccess {
              result {
                blobId
                attachmentType
                fileName
                hasConvertedPdf
              }
            }
            ... on ResponseError {
              error
            }
          }
          source
          job {
            ... on ApplicationJobResponseSuccess {
              result {
                id
                title
              }
            }
            ... on ResponseError {
              error
            }
          }
        }
      }
      ... on ResponseError {
        error
      }
    }
  }
`;

export const fetchPreviousApplications = async (
  variables: PreviousApplicationsQueryVariables,
) => {
  const result = await hirerGraphClient.query<
    PreviousApplicationsQuery,
    PreviousApplicationsQueryVariables
  >({
    variables,
    query,
  });

  return result.data;
};
